interface FirstStepRedirectInput {
  step?: string;
  pageCount: number;
  firstPageId: string;
  pathname: string;
  search?: string;
}

// Routes declared with an optional step (`:step?`) render the first page when the step is
// missing, but the nav links and page titles read the URL. Returns the URL that adds that
// first step, or null when there is nothing to add.
export const getFirstStepRedirect = ({
  step,
  pageCount,
  firstPageId,
  pathname,
  search = ''
}: FirstStepRedirectInput): string | null => {
  if (step || pageCount < 2) {
    return null;
  }

  return `${pathname.replace(/\/$/, '')}/${firstPageId}${search}`;
};
